export const CALC_BY_FLAT = 'CALC_BY_FLAT'
export const CALC_BY_FLAT_LEGACY = 'CALC_BY_FLAT_LEGACY'
export const CALC_BY_ALL = 'CALC_BY_ALL'
export const CALC_BY_ALL_LEGACY = 'CALC_BY_ALL_LEGACY'
